
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { ValidationService } from '../../../../../shared/_services/validation.service';
import { HcaManagementService } from '../../../../../shared/_services/hca-management.service';
import { Router } from '@angular/router';
import { ImageFile } from '../../../../../shared/_data-model/image-file';
import { UtilService } from '../../../../../shared/_services/util.service';
import { environment } from '../../../../../../environments/environment';
import { StatusModalComponent } from '../../../../modals/status-modal/status-modal.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
@Component({
  selector: 'app-hca-add',
  templateUrl: './hca-add.component.html',
  styleUrls: ['./hca-add.component.scss']
})
export class HcaAddComponent implements OnInit {
  errorDetails: any;
  imageFile: ImageFile = new ImageFile;
  statusModal: BsModalRef;
  hotelChain: any = FormGroup;
  private unsubscribe: Subject<void> = new Subject<void>();
  showLoader: boolean = false;
  errorUpload: any;
  fileSizeError: any;
  @ViewChild('uploadFile') uploadFile: any;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private validationService: ValidationService,
    private hcamanagementservice: HcaManagementService,
    private utilService: UtilService,
    private modalService: BsModalService,
  ) {  
    this.modalService.onHide
    .takeUntil(this.unsubscribe).subscribe(res => {
      if (this.statusModal) {
      if (this.statusModal.content.srcObject.action == "action1") {
        if (this.statusModal && this.statusModal.content && this.statusModal.content.srcObject && this.statusModal.content.srcObject.type == "hca-image") {
          this.imageFile.imageUrl = "";
        }
      }
    }
    })
  }

  getUrl = function (source) {
    return source ? source : '#';
  }

  save() {
    if(environment.ROLE == 'lsa') {
      this.showLoader = true;
    }
    this.hcamanagementservice.saveHotelChain(this.hotelChain.value).subscribe(
      res => {
        if (res.error == 0) {
          this.router.navigate(['/hca-management']);
        } else {
          this.errorDetails = res.message;
        }
        if(environment.ROLE == 'lsa') {
          this.showLoader = false;
        }
      }, error => {
        console.error(error);
        if(environment.ROLE == 'lsa') {
          this.showLoader = false;
        }
        this.errorDetails = error.message;
      }
    );
  }
  uploadImage(event: any) {
    this.imageFile = this.utilService.uploadImage(event);
    this.errorUpload = this.imageFile.errorUpload;
    this.fileSizeError = this.imageFile.fileSizeError;
    if (!this.imageFile.errorUpload && !this.imageFile.fileSizeError) {
      //  File Should be saved first
      let formData: any = new FormData();
      let fileName = this.imageFile.name ? `${this.utilService.getRandomInt(0, 1000000)}_${this.imageFile.name}` : this.utilService.getRandomInt(0, 1000000);
      formData.append('image', this.imageFile.file, fileName);
      this.utilService.uploadFile(formData).subscribe((res) => {
        if (res.error == 0) {
          this.hotelChain.get('logo').patchValue(res.responseObj);
        }
        else {
          console.log("Error uploading file");
        }
        this.resetFileInput('uploadFile');
      })
    } else {
      this.hotelChain.get('logo').patchValue('');
      this.imageFile.imageUrl = '';
      this.imageFile.name = '';
      this.resetFileInput('uploadFile');
    }
    setTimeout(() => {
      this.errorUpload = false;
      this.fileSizeError = false;
    }, 1500);
  }

  resetFileInput(element?) {
    console.log(this[element].nativeElement.files);
    this[element].nativeElement.value = "";
    console.log(this[element].nativeElement.files);
  }

  deleteImage() {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'hca-image',
      title: 'Confirm',
      status: 'Active',
      message: 'Are you sure you want to delete this image?',
      action1: 'Yes',
      action2: 'No',
      action: '',
    }
  }
 
  ngOnInit() {
    this.hotelChain = this.fb.group({
      hotelChainName: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      contactMobile: ['', Validators.compose([Validators.minLength(8), Validators.maxLength(12), Validators.pattern(this.validationService.phoneNumber_regexPattern)])],
      // contactMobile: ['', Validators.compose([Validators.minLength(8), Validators.maxLength(15)])],
      // contactEmail: ['', Validators.compose([Validators.required, Validators.pattern(this.validationService.email_regexPattern)])],
      contactEmail: ['', Validators.compose([Validators.required])],
      address: [''],
      logo: ['']
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/lsa-admin/hotel-chain-management/hca-add/hca-add.component.ts